export type TSupportedLanguages = 'en' | 'vi' | 'id' | 'hi';

export enum ELocalesForSupportedLanguages {
  ENGLISH_US = 'en-US',
  VIETNAMESE = 'vi-VN',
  INDONESIAN = 'in-ID',
  HINDI = 'hi-IN',
}

// To create locales for new languages
// https://gist.github.com/mlconnor/1887156
// Locale is generated using --> ISO639-2 Lang '-' ISO639-2 Country Code
